import { CYMAJob } from '../utils/CYMAAPI';
import { createContext } from 'react';

type IJobsContext = [CYMAJob[], Function, () => void];

export const JobsContext = createContext<IJobsContext>([[], () => {}, () => {}]);

export default JobsContext;
